"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PopoverContent = _interopRequireDefault(require("./PopoverContent"));

var _PopupProvider = _interopRequireDefault(require("../Utility/PopupProvider"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * A popover component.
 */
var Popover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popover, _React$Component);

  function Popover() {
    _classCallCheck(this, Popover);

    return _possibleConstructorReturn(this, _getPrototypeOf(Popover).apply(this, arguments));
  }

  _createClass(Popover, [{
    key: "renderPopoverContent",

    /**
     * Render popover content
     * @param {object} props - props for popover content
     * @returns {ReactElement} popover content element
     */
    value: function renderPopoverContent(props) {
      return _react.default.createElement(_PopoverContent.default, props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          content = _this$props.content,
          padding = _this$props.padding,
          showCaret = _this$props.showCaret,
          title = _this$props.title,
          wrapperProps = _this$props.wrapperProps,
          props = _objectWithoutProperties(_this$props, ["className", "content", "padding", "showCaret", "title", "wrapperProps"]);

      return _react.default.createElement(_PopupProvider.default, _extends({
        popup: this.renderPopoverContent({
          content: content,
          padding: padding,
          showCaret: showCaret,
          title: title,
          wrapperProps: wrapperProps
        }),
        popupClassName: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-popover")),
        prebuiltPlacementMap: "offset10px",
        transitionType: "zoom-big"
      }, props));
    }
  }]);

  return Popover;
}(_react.default.Component);

exports.default = Popover;
Popover.PopoverContent = _PopoverContent.default;
Popover.defaultProps = {
  action: 'click',
  padding: '20px',
  popupPlacement: 'top',
  showCaret: true
};
Popover.propTypes = {
  /**
   * Event to trigger popover.
   */
  action: _propTypes.default.oneOf(['hover', 'click', 'focus', 'contextMenu']),

  /**
   * This is the component/text the popover will pop over.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Custom class name for popover.
   */
  className: _propTypes.default.string,

  /**
   * This is the component/text to be placed inside the popover.
   */
  content: _propTypes.default.node.isRequired,

  /**
   * Container to place popover in. Use when popover will scroll with content from a source other
   * than the body. e.g. `() => document.querySelector('.right-panel')`
   */
  getPopupContainer: _propTypes.default.func,

  /**
   * Called when popover visibility changes.
   */
  onPopupVisibleChange: _propTypes.default.func,

  /**
   * Padding around content.
   */
  padding: _propTypes.default.oneOf(['0px', '20px']),

  /**
   * Placement position of popover over children.
   */
  popupPlacement: _propTypes.default.oneOf(['leftTop', 'left', 'leftBottom', 'topLeft', 'top', 'topRight', 'rightTop', 'right', 'rightBottom', 'bottomLeft', 'bottom', 'bottomRight']),

  /**
   * Set visibility of popover. Note: This will override and ignore state of the 'action' prop.
   */
  popupVisible: _propTypes.default.bool,

  /**
   * Show popup caret.
   */
  showCaret: _propTypes.default.bool,

  /**
   * Title of popover
   */
  title: _propTypes.default.node,

  /**
   * Props to be passed to wrapping dom element
   */
  wrapperProps: _propTypes.default.object
};